import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { PAY_URL } from '../../../BaseURL';
import axios from 'axios';
import toast from 'react-hot-toast';
import moment from 'moment';

const months = [
    { number: 1, name: "1 - January", pureName: "January" },
    { number: 2, name: "2 - February", pureName: "February" },
    { number: 3, name: "3 - March", pureName: "March" },
    { number: 4, name: "4 - April", pureName: "April" },
    { number: 5, name: "5 - May", pureName: "May" },
    { number: 6, name: "6 - June", pureName: "June" },
    { number: 7, name: "7 - July", pureName: "July" },
    { number: 8, name: "8 - August", pureName: "August" },
    { number: 9, name: "9 - September", pureName: "September" },
    { number: 10, name: "10 - October", pureName: "October" },
    { number: 11, name: "11 - November", pureName: "November" },
    { number: 12, name: "12 - December", pureName: "December" }
];

const TransferSalaryModal = ({
    transferModal,
    handleHideTransferModal,
    title,
    text,
    url,
    handleTransferSuccess,
    tokenKey = 'PAY_USER_TOKEN',
    profileUrl = '/user/get-profile',
}) => {
    const [modalData, setModalData] = useState({ password: '', month: '' });
    const [showEye, setShowEye] = useState(true);
    const [disable, setDisable] = useState(false);
    const [elapsedTime, setElapsedTime] = useState(0);
    const [year, setYear] = useState('');
    const [error, setError] = useState({});
    const [yearData, setYearData] = useState([]);

    useEffect(() => {
        getProfile();
    }, [])

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes} min ${seconds} sec`;
    };

    const handleMonthToChange = (e) => {
        setModalData({ ...modalData, month: e.target.value });
    };

    // const getMonthFrom = () => {
    //     const selectedMonthIndex = parseInt(modalData.month, 10) - 1;
    //     const prevMonthIndex = (selectedMonthIndex - 1 + 12) % 12;
    //     return monthNames[prevMonthIndex];
    // };

    const getMonthFrom = () => {
        const selectedMonth = months.find(m => m.number === parseInt(modalData.month));
        if (!selectedMonth) return '';
        const prevMonthIndex = (selectedMonth.number - 2 + 12) % 12;
        return months[prevMonthIndex].name;
    };

    const getProfile = () => {
        axios({
            method: 'get',
            url: `${PAY_URL}${profileUrl}`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded', Authorization: "Bearer " + localStorage.getItem(tokenKey)
            }
        }).then((response) => {
            if (response.data.success === true) {
                setYearData(response.data.data.year);
            } else {
                toast.error(response.data.message);
            }
        }).catch((error) => {
            toast.error(error?.response?.data?.message);
        });
    }

    useEffect(() => {
        if (!transferModal) {
            setModalData({ password: '', month: '' });
            setDisable(false);
            setElapsedTime(0);
        }
    }, [transferModal])

    const handleSubmitSalary = () => {
        if (validation()) {
            setDisable(true);
            const interval = setInterval(() => {
                setElapsedTime((prev) => prev + 1);
            }, 1000);
            setDisable(true);
            const bodyFormData = new URLSearchParams();
            bodyFormData.append('password', modalData.password);
            bodyFormData.append('month', modalData.month);
            bodyFormData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
            bodyFormData.append('financial_year', year);
            bodyFormData.append('is_fi_year', year !== "" ? true : false);

            axios({
                method: 'post',
                url: `${PAY_URL}/user/${url}`,
                data: bodyFormData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: "Bearer " + localStorage.getItem(tokenKey) }
            }).then((response) => {
                clearInterval(interval);
                if (response.data.success === true) {
                    toast.success(response.data.message);
                    handleHideTransferModal();
                    setModalData({ password: '', month: '' });
                    handleTransferSuccess();
                } else {
                    toast.error(response.data.message);
                }
            }).catch((error) => {
                clearInterval(interval);
                toast.error(error?.response?.data?.message);
            }).finally(() => {
                setDisable(false);
                setElapsedTime(0);
            })
        }
    };

    const validation = () => {
        let isValid = true;
        let err = {};
        if (!modalData.password) {
            isValid = false;
            err['password_err'] = "Please enter password";
        }
        if (!modalData.month) {
            isValid = false;
            err['month_err'] = "Please select month";
        }
        setError(err);
        return isValid;
    }

    return (
        <Modal show={transferModal} onHide={handleHideTransferModal} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <h4 className='text-center mb-3'>{title} As Per Month</h4>
                    <div className='row my-2'>
                        {modalData.month && (
                            <div className='col-12'>
                                <div className="input-group mb-3">
                                    <span className="input-group-text">Month From</span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={getMonthFrom()}
                                        readOnly
                                    />
                                </div>
                            </div>
                        )}
                        <div className='col-12 mb-3'>
                            <div className="input-group">
                                <span className="input-group-text">Month To</span>
                                <select
                                    className="form-select form-control"
                                    value={modalData.month}
                                    onChange={handleMonthToChange}
                                >
                                    <option value="" disabled>Select Month</option>
                                    {months.map((month) => (
                                        <option key={month.number} value={month.number}>
                                            {month.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className='error'>{error?.month_err}</div>
                        </div>
                        <div className='col-12 mb-3'>
                            <div className="input-group">
                                <span className="input-group-text">Password</span>
                                <input
                                    type={showEye ? "password" : "text"}
                                    className="form-control position-relative"
                                    value={modalData.password}
                                    onChange={(e) => setModalData({ ...modalData, password: e.target.value })}
                                />
                                {showEye ? (<div className='tranfer-eye' onClick={() => { setShowEye(false) }}><i className="fa-solid fa-eye" /></div>) :
                                    (<div className='tranfer-eye' onClick={() => { setShowEye(true) }}><i className="fa-solid fa-eye-slash" /> </div>)}
                            </div>
                            <div className='error'>{error?.password_err}</div>
                        </div>
                        {parseInt(modalData.month) === 4 && (
                            <div className='col-12 mb-3'>
                                <div className="input-group">
                                    <span className="input-group-text">Year</span>
                                    <select
                                        className="form-select form-control"
                                        value={year} name='year'
                                        onChange={(e) => setYear(e.target.value)}
                                    >
                                        <option value="">Select Year</option>
                                        {yearData.map((yr, i) => (
                                            <option key={i} value={yr._id}>
                                                {moment(yr.start_year).format("YYYY")}-{moment(yr.end_year).format("YYYY")}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <p><b>Note:</b> <small>Please select the month for which you would like to transfer the {text}.</small></p>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleHideTransferModal}>
                    Close
                </Button>
                <Button className='btn btn-success' onClick={handleSubmitSalary} disabled={disable}>
                    {disable ? `Processing... (${formatTime(elapsedTime)})` : 'Transfer'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TransferSalaryModal;